module.exports = "//a.spikex.com/sigma/frontend-ssr-web-index/_next/static/images/smartbg-b001c72373eac5fd83f4ce9d4b2b97f9.png";